import Activation from './Activation.view';

export default Activation;
